import styled, { keyframes } from 'styled-components';
import { zIndexModal } from '../../constants';
export const Wrapper = styled.div `
  position: relative;
`;
export const fadeDownAndIn = (x, y) => keyframes `
  0% {
    opacity: 0;
    transform: translate(${x}px, ${y - 10}px);
  }

  100% {
    opacity: 1;
    transform: translate(${x}px, ${y}px);
  }
`;
export const Panel = styled.div `
  display: ${({ active }) => (active ? 'block' : 'none')};
  position: absolute;
  z-index: ${zIndexModal};
  top: 10px;
  left: 0px;
  background-color: red;
  animation: ${({ top, left }) => fadeDownAndIn(left, top)} 0.6s forwards;
  background: white;
  border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  border-radius: 3px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
`;
//# sourceMappingURL=styles.js.map